import type { VirtuosoProps } from 'react-virtuoso';
import { Virtuoso } from 'react-virtuoso';
import { Animation } from '@kcd/design-system';
import LoadingDotAnimationData from '@kcd/design-system/dist/assets/animations/loading-dot.json';

export type Props<TData, TContext> = VirtuosoProps<TData, TContext> & {
  isFetchingNextPage?: boolean;
};

export default function VirtualizedList<TData, TContext>({
  isFetchingNextPage,
  useWindowScroll = true,
  ...props
}: Props<TData, TContext>) {
  return (
    <Virtuoso
      {...props}
      useWindowScroll={useWindowScroll}
      components={{
        Footer: function Footer() {
          if (!isFetchingNextPage) {
            return null;
          }

          return (
            <div className="flex justify-center">
              <Animation
                loop
                speed={2}
                size={64}
                data={LoadingDotAnimationData}
              />
            </div>
          );
        },
      }}
    />
  );
}
